import Vue from 'vue';
import CallToAction from './CallToAction.vue';

const MxrCallToAction = Vue.component('mxr-call-to-action', CallToAction);

export { MxrCallToAction };
